import { Form, Input } from "decorator-form";

import { ID } from "common/entities/IEntity";
import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { Entity, Field } from "typegraph";
import { ILayout } from "../../../common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "../../../core/components/FragmentLayout";
import { FragmentProvider } from "../../../core/components/FragmentProvider";
import * as fragments from "../fragments/fragments";

// tslint:disable:max-classes-per-file

@Entity({many: "tagSets"})
class TagSet {
	@Field() public id: any;
	@Field() public name: string;
}

const tagSetSelect = EntitySelect.registered({
	entity: TagSet,
	type: 'many'
}, 'string');

// EntityMultiSelect.registered(TagSet, {pageSize: 100});

const editLocation = ButtonSelect.registerWithOptions([
	{value: 'dialog', label: 'Dialog'},
	{value: 'panel', label: '(not implemented yet)'},
	{value: 'redirect', label: '(not implemented yet)'}
]);

const resultsLayoutInput = FragmentProvider.getLayoutInput(fragments);

@Form({title: "User Tags Panel Config"})
export default class UserTagsPanelConfig {

	@Input({type: InputType.CHECKBOX, title: "Auto Prompt"})
	public autoPrompt: boolean;

	@Input({
		type: InputType.NUMBER_POSITIVE,
		title: "Max Selected Tags To Show",
		description: "set to 0 for unlimited"
	})
	public maxVisibleSelected?: number = 0;

	@Input({type: editLocation, title: "Tag Edit Location"})
	public editLocation: 'dialog' | 'panel' | 'redirect';

	@Input({type: tagSetSelect, title: "Tag Sets"})
	public tagSets: ID[];

	@Input({type: InputType.CHECKBOX, title: "Bundle Tags Only"})
	public bundleTagsOnly: boolean;

	@Input({type: resultsLayoutInput, title: "Result Fragments"})
	public resultsLayout: ILayout<IFragmentLayoutConfig>;


}



// WEBPACK FOOTER //
// ./src/panels/tags/config/UserTagsPanelConfig.ts